import { ProfileCity } from 'app/design/icons/profile-city';
import { ShareAndroid } from 'app/design/icons/shareAndroid';
import { Column, Row } from 'app/design/primitives/box';
import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface Properties {
  open: boolean;
  onClose: () => void;
  onJoin: () => void;
  isJoining: boolean;
}

export function JoinPlaceBottomSheet({ open, onClose, onJoin, isJoining }: Properties) {
  const { t } = useTranslation();

  return (
    <BottomSheet open={open} onClose={onClose}>
      <Column
        gap="spacing.general.x4"
        style={{
          paddingHorizontal: theme.spacing['spacing.general.x5'],
          paddingBottom: theme.spacing['spacing.general.x12'],
        }}
      >
        <Text fontWeight="700" variant="headerXSmall">
          {t('place.joinTitle', { ns: 'neighbour-profile' })}
        </Text>

        <Row alignItems="flex-start" gap="spacing.general.x4">
          <Column
            alignItems="center"
            justifyContent="center"
            style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: theme.colors['surface.tertiary-neutral'],
            }}
          >
            <ProfileCity color={theme.colors['text.primary']} width={20} height={20} />
          </Column>
          <Column flex={1} gap="spacing.general.x0,5">
            <Text fontWeight="600" variant="bodyBase">
              {t('place.join.profileTitle', { ns: 'neighbour-profile' })}
            </Text>
            <Text color="text.placeholder" variant="bodyBase">
              {t('place.join.profileDesc', { ns: 'neighbour-profile' })}
            </Text>
          </Column>
        </Row>

        <Row alignItems="flex-start" gap="spacing.general.x4">
          <Column
            alignItems="center"
            justifyContent="center"
            style={{
              width: 40,
              height: 40,
              borderRadius: 20,
              backgroundColor: theme.colors['surface.tertiary-neutral'],
            }}
          >
            <ShareAndroid color={theme.colors['text.primary']} width={20} height={20} />
          </Column>
          <Column flex={1} gap="spacing.general.x0,5">
            <Text fontWeight="600" variant="bodyBase">
              {t('place.join.offersTitle', { ns: 'neighbour-profile' })}
            </Text>
            <Text color="text.placeholder" variant="bodyBase">
              {t('place.join.offersDesc', { ns: 'neighbour-profile' })}
            </Text>
          </Column>
        </Row>

        <Button
          flex={1}
          justifyContent="center"
          loading={isJoining}
          minHeight={48}
          onPress={onJoin}
          style={{ borderRadius: theme.borderRadii['radius.xl'] }}
          variant="primary"
        >
          <Text color="text.inverse.primary" fontWeight="700" textAlign="center" variant="bodyBase">
            {t('place.confirm', { ns: 'neighbour-profile' })}
          </Text>
        </Button>

        <Button
          flex={1}
          justifyContent="center"
          minHeight={48}
          onPress={onClose}
          style={{
            borderRadius: theme.borderRadii['radius.xl'],
            borderWidth: 1.5,
            borderColor: theme.colors['surface.disabled'],
          }}
        >
          <Text fontWeight="600" textAlign="center" variant="bodyBase">
            {t('cancel', { ns: 'common' })}
          </Text>
        </Button>
      </Column>
    </BottomSheet>
  );
}
